import { Component, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { faFile, faTimes } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-file-input",
  templateUrl: "./file-input.component.html",
  styleUrls: ["./file-input.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileInputComponent),
      multi: true,
    },
  ],
})
export class FileInputComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() fileTypes: string[];
  @Input() multiple = true;
  closeIcon = faTimes;
  fileIcon = faFile;

  onChange: any = () => {};
  onTouch: any = () => {};

  val = ""; // value of the component
  filenames = [];
  errorMessage: string = "";

  @ViewChild("fileInput", { static: false }) fileInput;

  constructor() {}

  ngOnInit(): void {}

  set value(val) {
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {}

  writeValue(value: any): void {
    this.value = value;

    if (!value) {
      delete this.filenames;
    }
  }

  uploadFile(files: any) {
    this.errorMessage = "";
    if (this.multiple) {
      // FileType check for all files
      if (this.fileTypes && this.fileTypes.length > 0) {
        const invalidFiles = Array.from(files).filter((file) => {
          const ext = (file as File).name.split(".").pop().toLowerCase();
          return !this.fileTypes.map((ft) => ft.toLowerCase()).includes(ext);
        });
        if (invalidFiles.length > 0) {
          this.errorMessage = `Invalid file type(s): ${invalidFiles
            .map((f) => (f as File).name)
            .join(", ")}. Allowed: ${this.fileTypes.join(", ")}`;
          return;
        }
      }
      if (this.val) {
        this.value = Array.from(this.val).concat(Array.from(files));
        this.filenames = this.filenames.concat(
          Array.from(files).map((file) => file["name"])
        );
      } else {
        this.value = files;
        this.filenames = Array.from(files).map((file) => file["name"]);
      }
    } else {
      const fileType =
        files[0].type || files[0].name.split(".").length > 0
          ? files[0].name.split(".").slice(-1)[0]
          : "";
      if (this.fileTypes && this.fileTypes.length > 0) {
        const ext = files[0].name.split(".").pop().toLowerCase();
        if (this.fileTypes.map((ft) => ft.toLowerCase()).includes(ext)) {
          this.value = files[0];
          this.filenames = [files[0].name];
        } else {
          this.errorMessage = `Invalid file type: ${
            files[0].name
          }. Allowed: ${this.fileTypes.join(", ")}`;
        }
      } else {
        // No file type restrictions, accept any file
        this.value = files[0];
        this.filenames = [files[0].name];
      }
    }
  }

  deleteFile() {
    this.value = "";
    this.fileInput.nativeElement.value = "";
    this.filenames = [];
  }
}
